import { ENV } from '@/lib/env'
import { AppError } from './AppError'

export function handleError(error: unknown, context?: Record<string, any>) {
  if (error instanceof AppError) {
    // Erreur opérationnelle prévue
    if (error.statusCode >= 500) {
      // Log to console in development
      if (ENV.IS_STAGING) {
        console.error(`${new Date().toISOString()} [Next.js] ERROR Server error:`, error)
      }
      // TODO: Send to Sentry when configured
      // Sentry.captureException(error, { contexts: { custom: context } })
    }
    return {
      error: error.message,
      code: error.code,
      statusCode: error.statusCode,
    }
  }

  // Erreur inattendue
  console.error(`${new Date().toISOString()} [Next.js] ERROR Unexpected error:`, error)
  // TODO: Send to Sentry when configured
  // Sentry.captureException(error, { contexts: { custom: context } })

  return {
    error: 'An unexpected error occurred',
    code: 'INTERNAL_ERROR',
    statusCode: 500,
  }
}
